/**
 * Guarantees a base URL ends in exactly one slash, so callers can append a
 * bare path (`${base}scanner/...`) without producing a mangled URL.
 *
 * `VITE_CONSUMER_APP_URL` reaches the frontends from two sources that disagree
 * about the trailing slash: Pulumi exports it with one
 * (`consumerAppUrl` in infrastructure/prod/src/consumer_app.ts), while the PR
 * preview workflow passes a bare origin. Concatenating the bare form is what
 * put `https://app-prd-123.preview.tdcdev.comscanner/...` into the document
 * scanner QR codes. Normalising at the config boundary means no call site has
 * to know which form it was handed.
 */
export const withTrailingSlash = (url: string): string =>
  `${url.replace(/\/+$/, '')}/`;
